import { formatMoney, formatNumber } from 'accounting'

export const pounds = value => {
  return formatMoney(value, '£', 0)
}

export const number = value => {
  return formatNumber(value)
}
